<template>
  <div v-if="item.attributes.uploading" class="content-loading-container item-container justify-content-center d-flex flex-column" data-testid="loading-gif">
    <img src="@img/cloud-loader.gif">
    <div v-if="showUploadingText" class="text-center" v-cloak>
      <h4>{{header}}</h4>
      <p class="text-muted">This may take several minutes. If you have any questions please email us at <a href="mailto:support@getcloudapp.com" class="support-link" data-testid="support-email-link">support@getcloudapp.com &rarr;</a></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: function(){
    return {
      showUploadingText: false,
    }
  },
  computed: {
    ...mapState(['item']),
    header: function(){
      return this.item.attributes.action_type == 'gt' ? 'Processing gif...' : 'Content is being uploaded.'
    }
  },
  created: function(){
    const vm = this;
    setTimeout(function(){ vm.showUploadingText = true }, 10000)
  }
}
</script>
